module.exports = __webpack_public_path__ + "img/lagoon-logo.3326ddb6.svg";